import { useMemo } from "react";
import HiddenPageForm from "../HiddenPageForm";
import { HiddenPageProps } from "../HiddenPageSingle";
import { BodyCondition } from "../../../models/Quote";
import enumToOptions from "../../../utils/enumToOptions";

export default function HiddenBodyCondition({register, setValue, watch}: HiddenPageProps) {
  const conditionOptions = useMemo(() => enumToOptions(BodyCondition), []);

  const schema = [
    {
      key: "bodyCondition",
      label: "Body Condition",
      type: "select",
      options: conditionOptions,
    },
  ]

  return (
    <HiddenPageForm 
      title={"Body Condition"}
      description={"Fill out the body condition details to prefill for this page."}
      register={register} 
      setValue={setValue} 
      watch={watch}
      schema={schema}
    />
  );
}